import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
  HttpParams
} from '@angular/common/http';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/of';
import {Observable} from 'rxjs/Observable';
import {LocationStrategy, PathLocationStrategy} from '@angular/common';
import {ToasterService, Toast, BodyOutputType} from 'angular2-toaster';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private useSuccessToastr : string = 'true';

  constructor(
    private location: LocationStrategy,
    private toasterService: ToasterService,
    private router: Router,
    private authService: AuthService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // lock a submit button if there is one on the page
    const elem = <HTMLInputElement>document.getElementById("submit");
    if (elem && !req.params.get("ignoreLockingSubmitButton")) {
      elem.disabled = true;
    }
    // lock a decline submit button if there is one on the page
    const elem2 = <HTMLInputElement>document.getElementById("submitDecline");
    if (elem2 && !req.params.get("ignoreLockingSubmitButton")) {
      elem2.disabled = true;
    }
    // Check to see if auth header needs to be used
    if (req.params.get('UseAuth') === 'true') {
      // Cancel all auth calls to our db if token is expired but user is inside an AuthGuarded page
      const cancelAuthCalls = this.authService.getCanCancelAuthCalls();
      this.useSuccessToastr = req.params.get('UseSuccessToastr') ? req.params.get('UseSuccessToastr') : 'false';
      if (!cancelAuthCalls) {
      // Check if token is expired
        if (!this.authService.loggedIn()) {
          // const toast: Toast = {
          //   type: 'warning',
          //   title: 'Unauthorized',
          //   body: 'Login Required.'
          // };
          // this.toasterService.pop(toast);
          this.authService.logout();
          return Observable.of(undefined);
        }
        else {
          // Remove UseAuth param, as well as the UseSuccessToastr param
          const link_id = this.authService.getLinkID();
          const login_type = this.authService.getLoginType();

          const params = new HttpParams().delete('UseAuth').delete('UseSuccessToastr');
          // Get the auth header from the service.
          const authHeader = 'Bearer ' + localStorage.getItem('externalToken');
          // Clone the request to and add the new header.
          const authReq = req.clone({setHeaders: {
            Authorization: authHeader, LinkId: link_id.toString(), LoginType: login_type},
             params: params});
          // Pass on the cloned request instead of the original request.
          return next
            .handle(authReq)
            .do(
              evt => {
                if (evt instanceof HttpResponse) {
                  this.handleHttpResponse(evt, this.toasterService)
                }
              })
            .catch((error: HttpErrorResponse) => {
              return this.handleHttpError(error, this.location, this.toasterService);
            })
            .finally(() => {
              if (elem && !req.params.get("ignoreLockingSubmitButton")) {
                elem.disabled = false;
              }
              if (elem2 && !req.params.get("ignoreLockingSubmitButton")) {
                elem2.disabled = false;
              }
            });
        }
      }
      // Users are in AuthGuarded page but no longer logged in, do not let them touch the backend
      else {
        // We need to return something or we set off the GlobalErrorHandler in frontend-error.handler.ts
        return Observable.of(undefined);
      }
    }
    else {
      return next
        .handle(req)
        .catch((error: HttpErrorResponse) => {
          return this.handleHttpError(error, this.location, this.toasterService);
        })
        .finally(() => {
          if (elem && !req.params.get("ignoreLockingSubmitButton")) {
            elem.disabled = false;
          }
          if (elem2 && !req.params.get("ignoreLockingSubmitButton")) {
            elem2.disabled = false;
          }
        });
    }
  }


  // Not that if Promise was turned into Observable (as it was before), it wouldn't kill the call and function would still
  // step into the 'then' part
  private handleHttpError(error: HttpErrorResponse, location: LocationStrategy, toasterService: ToasterService): Promise<any> {
    console.error(error.message);
    let toast: Toast;
    if (error.status === 404) {
        toast = {
          type: 'error',
          title: 'Not Found',
          body: 'Sorry, but we do not have that item.'
        };
    } else if (error.status === 401 ) {
      // toast = {
      //       type: 'warning',
      //       title: 'Unauthorized',
      //       body: 'Login Required.'
      //     };
      this.authService.logout();
      return Promise.reject('Error');
    } else if (error.status === 413 ) {
      toast = {
            type: 'warning',
            title: 'File Size Exceeded',
            body: 'File size may not exceed 10 MB.'
          };
    } else if (error.status === 414 ) {
      toast = {
            type: 'warning',
            title: error.error.title,
            body: error.error.message
          };
    } else if (error.status === 422 ) {
      // Grab all messages from server
      const errors = [];
      let bodyHtml = '<ul>';
      for (const err in error.error) {
        errors.push(err)
        bodyHtml = bodyHtml + err + '</br>';
        if (error.error[err].length < 2) {
          bodyHtml = bodyHtml + '<li>' + error.error[err] + '</li>';
        }
        else {
          for (const err2 in error.error[err]) {
             bodyHtml = bodyHtml + '<li>' + err2 + '</li>';
          }
        }
      }
      bodyHtml = bodyHtml + '</ul>';
      toast = {
        type: 'warning',
        title: error.statusText,
        body: bodyHtml,
        bodyOutputType: BodyOutputType.TrustedHtml
      };
    } else {
        // toast = {
        //   type: 'error',
        //   title: 'Server Error',
        //   body: 'Hmmm..... an error occurred. The dev team has been notified.',
        //   timeout: 15000
        // };
      return Promise.reject('Error');
    }
    toasterService.pop(toast);
    return Promise.reject(error.message);
  }

  private handleHttpResponse(res: any, toasterService: ToasterService): void {
    if (res.status !== 200 && this.useSuccessToastr === 'true') {
      const toast: Toast = {
        type: 'success',
        title: 'Successful Save',
        body: 'Changes have been saved'
      };
      toasterService.pop(toast);
    }
  }
}
